import { lazy } from "react";

const TimeConfigPage = lazy(() => import("./main"));
const CreateTimeConfigPage = lazy(() => import("./create"));
const UpdateTimeConfigPage = lazy(() => import("./update"));

export { TimeConfigPage, CreateTimeConfigPage, UpdateTimeConfigPage };
